import DateRangePicker from 'rsuite/DateRangePicker';
import { datetimeFormats } from '../constants';

const { combine, allowedMaxDays, afterToday } = DateRangePicker;

export const SelectDateRange = (props) => {
  return (
    <DateRangePicker
      value={props.range}
      onChange={(value) => props.onChange(value)}
      onOk={(value) => props.onChange(value)}
      character=" &#8211; "
      cleanable={props.cleanable}
      shouldDisableDate={combine(allowedMaxDays(props.maxDays), afterToday())}
      // disabledDate={}
      editable={false}
      format={datetimeFormats.picker}
      isoWeek
      showOneCalendar
      className="rs-picker-daterange-popper"
    />
  );
};
